export const INIT_BUYCART = 'INIT_BUYCART'
export const ADD_CART = 'ADD_CART'
export const GET_USERINFO = 'GET_USERINFO'
export const RECORD_USERINFO = 'RECORD_USERINFO'
export const ADD_ANIMATION = 'ADD_ANIMATION'
export const SHOW_CART = 'SHOW_CART'
export const REDUCE_CART = 'REDUCE_CART'
export const EDIT_CART = 'EDIT_CART'
export const INIT_CATEGORY = 'INIT_CATEGORY'
export const INIT_EXTEND_04 = 'INIT_EXTEND_04'
export const INIT_EXTEND_05 = 'INIT_EXTEND_05'
export const INIT_EXTEND_06 = 'INIT_EXTEND_06'
export const INIT_EXTEND_07 = 'INIT_EXTEND_07'
export const INIT_EXTEND_08 = 'INIT_EXTEND_08'
export const INIT_EXTEND_09 = 'INIT_EXTEND_09'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js